"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clipboardCopy = _interopRequireDefault(require("clipboard-copy"));

var _formatValue4 = _interopRequireDefault(require("./helpers/formatValue"));

var _index = _interopRequireDefault(require("../RenderIf/index"));

var _closeIcon = _interopRequireDefault(require("../Chip/closeIcon"));

var _index2 = _interopRequireDefault(require("../ButtonIcon/index"));

var _input = _interopRequireDefault(require("./styled/input"));

var _selectedInput = _interopRequireDefault(require("./styled/selectedInput"));

var _selectedValueIcon = _interopRequireDefault(require("./styled/selectedValueIcon"));

var _selectedValueContainer = _interopRequireDefault(require("./styled/selectedValueContainer"));

var _selectedValueClearButton = _interopRequireDefault(require("./styled/selectedValueClearButton"));

var SelectedValue = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SelectedValue, _Component);

  function SelectedValue(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectedValue);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SelectedValue).call(this, props));
    _this.inputRef = _react["default"].createRef();
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SelectedValue, [{
    key: "handleFocus",
    value: function handleFocus() {
      var value = this.props.value;

      var _formatValue = (0, _formatValue4["default"])(value),
          label = _formatValue.label;

      (0, _clipboardCopy["default"])(label);
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: "focus",
    value: function focus() {
      this.inputRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.inputRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.inputRef.current.blur();
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          disabled = _this$props.disabled,
          tabIndex = _this$props.tabIndex,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          onClick = _this$props.onClick,
          errorMessageId = _this$props.errorMessageId,
          error = _this$props.error;

      var _formatValue2 = (0, _formatValue4["default"])(value),
          label = _formatValue2.label,
          icon = _formatValue2.icon;

      if (readOnly) {
        return _react["default"].createElement(_input["default"], {
          id: id,
          name: name,
          type: "text",
          value: label,
          tabIndex: tabIndex,
          onFocus: this.handleFocus,
          onClick: onClick,
          disabled: disabled,
          readOnly: true,
          "aria-describedby": errorMessageId,
          required: required,
          ref: this.inputRef,
          iconPosition: "left",
          icon: icon,
          error: error
        });
      }

      return _react["default"].createElement(_selectedInput["default"], {
        id: id,
        name: name,
        type: "text",
        value: label,
        tabIndex: tabIndex,
        onFocus: this.handleFocus,
        onClick: onClick,
        disabled: disabled,
        readOnly: true,
        "aria-describedby": errorMessageId,
        required: required,
        ref: this.inputRef,
        iconPosition: "left",
        icon: icon,
        error: error
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          onClearValue = _this$props2.onClearValue;

      var _formatValue3 = (0, _formatValue4["default"])(value),
          icon = _formatValue3.icon;

      return _react["default"].createElement(_selectedValueContainer["default"], {
        readOnly: readOnly
      }, _react["default"].createElement(_index["default"], {
        isTrue: icon
      }, _react["default"].createElement(_selectedValueIcon["default"], {
        readOnly: readOnly
      }, icon)), this.renderInput(), _react["default"].createElement(_index["default"], {
        isTrue: !(readOnly || disabled)
      }, _react["default"].createElement(_selectedValueClearButton["default"], null, _react["default"].createElement(_index2["default"], {
        assistiveText: "clear",
        size: "small",
        title: "Remove selected option",
        icon: _react["default"].createElement(_closeIcon["default"], {
          color: "#576574"
        }),
        onClick: onClearValue
      }))));
    }
  }]);
  return SelectedValue;
}(_react.Component);

exports["default"] = SelectedValue;
SelectedValue.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    label: _propTypes["default"].string,
    description: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
    icon: _propTypes["default"].node
  }), _propTypes["default"].string]),
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onClick: _propTypes["default"].func,
  onClearValue: _propTypes["default"].func,
  errorMessageId: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
SelectedValue.defaultProps = {
  value: undefined,
  name: undefined,
  id: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  tabIndex: undefined,
  onClick: function onClick() {},
  onClearValue: undefined,
  errorMessageId: undefined,
  error: undefined
};